import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=4fc59249&scoped=true"
import script from "./Get.vue?vue&type=script&lang=js"
export * from "./Get.vue?vue&type=script&lang=js"
import style0 from "./Get.vue?vue&type=style&index=0&id=4fc59249&prod&lang=scss&scoped=true"
import style1 from "./Get.vue?vue&type=style&index=1&id=4fc59249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc59249",
  null
  
)

export default component.exports